$(function(){
	$('button.share-button').click(function(){
		var target = $(this).attr('class').split(' ')[1],
			el = $(this).parent().index(),
			at = $('.at-share-btn-elements');
		at.find('a').eq(el).find('*').click();
	});
});